module.exports = __webpack_public_path__ + "static/media/seletar.0eaab4a2.png";